import { BKJSideModal } from 'components/BKJSideModal';
import { FetchCommunitiesDataProvider } from 'modals/CustomFieldModal/Contexts/FetchCommunities.data.context';
import { FetchCommunitiesCountDataProvider } from 'modals/CustomFieldModal/Contexts/FetchCommunitiesCount.data.context';
import { FC, useMemo } from 'react';
import { withMemo } from 'utils/withMemo';
import {
  customFieldCreateModalRoutingService,
  CustomFieldCreateModalUIProvider,
  useCustomFieldCreateModalUIContext,
} from 'modals/CustomFieldCreateModal/contexts/CustomFieldCreateModal.ui.context';
import {
  CustomFieldCreateModalPropsProvider,
  useCustomFieldCreateModalPropsContext,
} from 'modals/CustomFieldCreateModal/contexts/CustomFieldCreateModal.props.context';
import { CustomFieldCreateModalFormProvider } from 'modals/CustomFieldCreateModal/contexts/CreateCustomField.form.context';
import {
  CustomFieldCreateModalViewMap,
  getHeaderComponent,
} from 'modals/CustomFieldCreateModal/CustomFieldCreateModal.views';
import { FetchCustomFieldsDataProvider } from 'pages/Settings/pages/CustomFields/contexts/FetchCustomFields.data.context';
import {
  ApplyFacilitiesFormProvider,
  useApplyFacilitiesFormContext,
} from 'modals/CustomFieldCreateModal/contexts/ApplyFacilities.form.context';

const CustomFieldModalComponent: FC = () => {
  const { createCustomFieldActiveModalView, isOpen } = useCustomFieldCreateModalUIContext();
  const { onClose } = useCustomFieldCreateModalPropsContext();
  const { onReset } = useApplyFacilitiesFormContext();

  const Component = useMemo(
    () => CustomFieldCreateModalViewMap[createCustomFieldActiveModalView],
    [createCustomFieldActiveModalView],
  );

  return (
    <BKJSideModal
      isOpen={isOpen}
      onClose={onClose!}
      headerComponent={getHeaderComponent(createCustomFieldActiveModalView)}
      showBackButton={customFieldCreateModalRoutingService.isBackButtonVisible()}
      onBack={() => {
        onReset();
        customFieldCreateModalRoutingService.goToPrevView();
      }}
    >
      {Component ? <Component /> : null}
    </BKJSideModal>
  );
};

const _CustomFieldModal: FC = () => (
  <CustomFieldCreateModalUIProvider>
    <FetchCommunitiesDataProvider>
      <FetchCommunitiesCountDataProvider>
        <FetchCustomFieldsDataProvider>
          <CustomFieldCreateModalPropsProvider>
            <CustomFieldCreateModalFormProvider>
              <ApplyFacilitiesFormProvider>
                <CustomFieldModalComponent />
              </ApplyFacilitiesFormProvider>
            </CustomFieldCreateModalFormProvider>
          </CustomFieldCreateModalPropsProvider>
        </FetchCustomFieldsDataProvider>
      </FetchCommunitiesCountDataProvider>
    </FetchCommunitiesDataProvider>
  </CustomFieldCreateModalUIProvider>
);

export const CustomFieldCreateModal = withMemo(_CustomFieldModal);
